var MapCenterPoint = ( state, action ) => {
    if ( action.type === 'mapcenter' ) {
        return action.payload
    } else {
        if ( undefined === state ) {
            return { init: true, coordinates:{ lat: 0, lng: 0 } };
        } else {
            return state
        }
    }
}
export const InfoBoxCenter = (  state, action  ) => {
    if ( action.type === 'infoboxcenter' ) {
        return action.payload
    } else {
        if ( undefined === state ) {
            return { lat: 48.8584, lng: 2.2945 };
        } else {
            return state
        }
    }
}
export default MapCenterPoint;